export class Address {
    _id?: string;
    telephone?: string = '';
    line1?: string = '';
    line2?: string = '';
    city?: string = '';
    postcode?: string = '';
    county?: string = '';
    country?: string = '';

    constructor () {
    }

  }



// WEBPACK FOOTER //
// ./client/app/shared/models/address.model.ts